var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmlplusBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.91687 4.08333L7.91687 14.9167C7.91687 15.515 8.40189 16 9.0002 16C9.59851 16 10.0835 15.515 10.0835 14.9167V4.08333C10.0835 3.48502 9.59851 3 9.0002 3C8.40189 3 7.91687 3.48502 7.91687 4.08333Z",
    fill: "#009ef7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4167 8.4165H3.58333C2.98502 8.4165 2.5 8.90153 2.5 9.49984C2.5 10.0981 2.98502 10.5832 3.58333 10.5832H14.4167C15.015 10.5832 15.5 10.0981 15.5 9.49984C15.5 8.90153 15.015 8.4165 14.4167 8.4165Z",
    fill: "#009ef7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmlplusBlue);
export default __webpack_public_path__ + "static/media/smlplus-blue.c22b301052b0e1952d8547a39433ba7c.svg";
export { ForwardRef as ReactComponent };